import React from 'react';
import useStepper from '../useStepper';
import { ButtonContainer, RouteButton } from '../../form';
import { Button } from 'react-bootstrap';
import { IStepperButtonsProps } from './types';

export const StepperButtons: React.FC<IStepperButtonsProps> = ({
  finishLabel,
  submitMode,
}) => {
  const {
    cancelPath,
    hasPrevious,
    hasNext,
    showNext,
    showPrevious,
    onFinish,
  } = useStepper();

  const handleClickNext = () => {
    if (submitMode) return;

    hasNext ? showNext() : onFinish();
  };

  return (
    <ButtonContainer>
      <RouteButton type="button" variant="secondary" to={cancelPath}>
        Cancel
      </RouteButton>
      {hasPrevious && (
        <Button variant="light" onClick={showPrevious}>
          Previous
        </Button>
      )}
      <Button
        type={submitMode ? 'submit' : 'button'}
        variant={hasNext ? 'primary' : 'success'}
        onClick={handleClickNext}
      >
        {hasNext ? 'Next' : finishLabel}
      </Button>
    </ButtonContainer>
  );
};

StepperButtons.defaultProps = {
  finishLabel: 'Finish',
};
